/**
 * 同时未两个元素并添加点击事件：
 * 1.banner中的按钮；
 * 2.订阅中的按钮；
 * ---------------------------------------------------------------------
 * 自动获取弹窗ID并绑定点击事件
 * 逻辑：从window.EcomSendApps.actions.initQueueMap的键中提取弹窗ID（键即为ID）
 * 优化点：增加超时机制、严格ID校验、减少无效轮询
 */

// 等待EcomSendApps及有效弹窗ID加载完成
function waitForPopupId({ maxWaitTime = 10000, interval = 500 } = {}) {
  return new Promise((resolve, reject) => {
    let checkCount = 0; // 检查次数计数器
    const maxCheckCount = Math.ceil(maxWaitTime / interval); // 最大检查次数（由超时时间和间隔计算）

    const checkInterval = setInterval(() => {
      checkCount++;

      // 1. 检查是否超时
      if (checkCount >= maxCheckCount) {
        clearInterval(checkInterval);
        reject(new Error(`Timeout: failed to get popup ID (exceeded ${maxWaitTime}ms)`));
        return;
      }

      // 2. 检查插件及initQueueMap是否存在
      if (!window.EcomSendApps?.actions?.initQueueMap) {
        // 未加载完成，继续等待（不打印警告，避免干扰）
        return;
      }

      // 3. 检查initQueueMap是否包含有效ID（键不为空）
      const popupIds = Object.keys(window.EcomSendApps.actions.initQueueMap);
      if (popupIds.length > 0) {
        clearInterval(checkInterval);
        resolve(popupIds[0]); // 返回第一个有效ID
      } else {
        // initQueueMap存在但无ID，继续等待（可能插件还在初始化）
        console.log("initQueueMap loaded, but no popup ID found yet, continuing to wait...");
      }
    }, interval);
  });
}

// 绑定点击事件
async function bindPopupTriggers() {
  try {
    // 等待弹窗ID（最长等待10秒，每500ms检查一次）
    const popupId = await waitForPopupId({
      maxWaitTime: 10000, // 最大等待时间（毫秒）
      interval: 500       // 检查间隔（毫秒）
    });

    // 绑定点击事件
    ["trigger-popup", "trigger-popup-subscription"].forEach((triggerId) => {
      const triggerEl = document.getElementById(triggerId);
      if (triggerEl) {
        triggerEl.addEventListener("click", () => {
          window.EcomSendApps.actions.showModal(true, true, popupId, true);
        });
      } else {
        console.warn(`Trigger element not found: ${triggerId}`);
      }
    });

  } catch (error) {
    // 统一处理所有错误（超时、无ID等）
    console.error("Failed to bind popup:", error.message);
  }
}

// 页面加载完成后执行
window.addEventListener("load", bindPopupTriggers);
